import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import SplashScreen from './components/SplashScreen';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import { getUserRoutes } from './routes';
import theme from './theme';
import { SessionExpiredModal } from './components/SessionExpiredModal';
import { RulesetEngine } from './pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset_engine/RulesetEngine';
import { useEffect, useState } from 'react';

const App = () => {
  const { isInitialized, user, isAuthenticated } = useAuth();
  const [isRulesetInitialized, setIsRulesetInitialized] = useState(false);

  const routes = getUserRoutes(user);
  const content = useRoutes(routes);
  useScrollReset();

  useEffect(() => {
    const initRuleset = async () => {
      if (isAuthenticated) {
        await RulesetEngine.init();
        setIsRulesetInitialized(true);
      }
    };

    if (isAuthenticated && !isRulesetInitialized) {
      initRuleset();
    }
  }, [isAuthenticated, isInitialized, isRulesetInitialized]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster position="top-center" />
        {isInitialized ? content : <SplashScreen />}
        <SessionExpiredModal />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
